import { render } from "./PotentionDetail.vue?vue&type=template&id=8d0321e2"
import script from "./PotentionDetail.vue?vue&type=script&lang=js"
export * from "./PotentionDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__